"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importDefault(require("react"));

const styled_components_1 = __importDefault(require("styled-components"));

const Selectable = _a => {
  var _b, _c;

  var {
    options,
    children
  } = _a,
      props = __rest(_a, ["options", "children"]);

  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(NativeSelect, Object.assign({}, props, {
    multiple: false
  }), options.map(_a => {
    var {
      label
    } = _a,
        option = __rest(_a, ["label"]);

    return react_1.default.createElement("option", Object.assign({
      key: option.value
    }, option), label);
  })), children({
    selected: (_c = (_b = options.filter(option => option.value === props.value)) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : options[0]
  }));
};

exports.default = Selectable;
const Wrapper = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
const NativeSelect = styled_components_1.default.select(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n"])));